import {
    DegreeIcon,
    ExperienceIcon,
    IdCardIcon,
    MobileIcon,
    PhoneIcon,
    ProfileLinkIcon,
    ResumeIcon,
} from '../../components/icons/icons';
const profileStyle = {
    width: '0.8em',
    height: '0.8em',
};

export const profileContent = [
    {
        name: 'candidate_id',
        contentLabel: 'ID ',
        contentIcon: <IdCardIcon sx={profileStyle} />,
        contentType: 'text',
    },
    {
        name: 'phone',
        contentLabel: 'Phone Number',
        contentIcon: <PhoneIcon sx={profileStyle} />,
        contentType: 'text',
    },
    {
        name: 'mobile',
        contentLabel: 'Mobile Number',
        contentIcon: <MobileIcon sx={profileStyle} />,
        contentType: 'text',
    },
    {
        name: 'degree',
        contentLabel: 'Degree',
        contentIcon: <DegreeIcon sx={profileStyle} />,
        contentType: 'text',
    },
    {
        name: 'experience',
        contentLabel: 'Experience',
        contentIcon: <ExperienceIcon sx={profileStyle} />,
        contentType: 'text',
    },
    {
        name: 'resume',
        contentLabel: 'Resume',
        contentIcon: <ResumeIcon sx={profileStyle} />,
        contentType: 'object',
    },
    {
        name: 'profile_link',
        contentLabel: 'Profile Link',
        contentIcon: <ProfileLinkIcon sx={profileStyle} />,
        contentType: 'link',
    },
];
